"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubmitButton = exports.Header = exports.Content = exports.Actions = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Content = exports.Content = (0, _mui.styled)(_mui.DialogContent)((param)=>{
    let { theme } = param;
    return {
        padding: 0,
        gap: theme.spacing(3),
        margin: theme.spacing(3, 0, 3),
        display: 'flex',
        flexDirection: 'column',
        minWidth: 'none',
        [theme.breakpoints.up('sm')]: {
            width: 330
        }
    };
});
const Actions = exports.Actions = (0, _mui.styled)(_mui.DialogActions)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(3),
        padding: 0,
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            marginBottom: 0
        }
    };
});
const Header = exports.Header = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        paddingTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingTop: 0
        }
    };
});
const SubmitButton = exports.SubmitButton = (0, _mui.styled)(_components.Button)(()=>({
        width: '100%'
    }));
